
export class PublishStoryComponentTextModel {
    confirmationInformation: string = 'Publish';
    authorTitle: string = 'Author';
    iAgree: string = 'I agree';
    agreePublish: string = 'Agree and Publish';
    cancel: string = 'Cancel';
    confirmationMessage: string = 'Are you sure that you want to publish story?';
    confirmation: string = 'Confirmation';
    publish: string = 'Publish';
    headerTitle: string = 'Newsroom';
    headerSubTitle: string = 'Almost Ready!';
    headerContent: string = 'Please review and verify the following information:';
    publishLoader: string = 'PUBLISHING ...';
}
